import axios from "axios";
const journalsListContainers = document.body.querySelectorAll(".journalsList");
console.log(journalsListContainers);
journalsListContainers.forEach((node) => {
  let endpoint;
  let journalsId = node.dataset.journals;
  endpoint =
    "/wp-json/wp/v2/journal?include=" + journalsId + "&orderby=include";

  axios
    .get(endpoint)
    .then((response) => {
      const journalsContainer = document.createElement("ul");
      journalsContainer.classList.add("journalsList__wrapper");
      response.data.forEach((res, index) => {
        const journal = document.createElement("li");
        journal.classList.add("journalsList__item");
        if (index % 2 !== 0) {
          journal.classList.add("journalsList__item--reverse");
        }
        journal.innerHTML = `
          <a class="journalsList__card" href="${res.link}">
            <div class="journalsList__infoContainer" style="background-image: url('${res.better_featured_image?.source_url}');">
              <span class="journalsList__infoWrapper">
                <span class="journalsList__clientNameContainer">
                  <span class="journalsList__clientName">${res.meta.work_client_name}</span>
                </span>
                <span class="journalsList__titleContainer">
                </span>
                <span class="journalsList__knowMoreContainer">
                </span>
              </span>
            </div>
            <div>
              <div class="journalsList__textContainer">
                <h3>${res.title.rendered}</h3>
              </div>
            </div>
          </a>
        `;
        console.log(res);
        journalsContainer.appendChild(journal);
      });

      node.innerHTML = "";
      node.appendChild(journalsContainer);
    })
    .catch((error) => {
      console.log(error);
    });
});
